import React from "react";
import {
  MessageCircle,
  Mail,
  Phone,
  Slack,
  Globe,
  Instagram,
  Send,
  Twitter,
  MessageSquare,
  AtSign,
  Headphones,
  Smartphone,
} from "lucide-react";

const integrations = [
  { icon: MessageCircle, label: "WhatsApp" },
  { icon: Mail, label: "Gmail" },
  { icon: Slack, label: "Slack" },
  { icon: Globe, label: "Webchat" },
  { icon: Instagram, label: "Instagram" },
  { icon: Send, label: "Telegram" },
  { icon: Twitter, label: "X / Twitter" },
  { icon: MessageSquare, label: "Intercom" },
  { icon: AtSign, label: "Outlook" },
  { icon: Headphones, label: "Zendesk" },
  { icon: Smartphone, label: "SMS" },
  { icon: Phone, label: "Voice" },
];

export default function LogoMarquee() {
  const row = [...integrations, ...integrations];
  return (
    <section
      data-testid="logo-marquee"
      className="border-y border-white/5 bg-[#0b0b12] py-10 relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-6 flex items-center justify-between">
        <span className="text-[11px] font-mono tracking-[0.2em] uppercase text-white/40">
          ── Native connectors across 40+ channels &amp; tools
        </span>
        <span className="hidden md:inline text-[11px] font-mono tracking-[0.2em] uppercase text-white/30">
          one inbox, every channel
        </span>
      </div>
      <div className="marquee-wrap relative">
        <div
          className="marquee-track flex gap-14 w-max"
          style={{ willChange: "transform" }}
        >
          {row.map((it, i) => (
            <div
              key={i}
              className="flex items-center gap-3 text-white/55 hover:text-white transition-colors"
              data-testid={`integration-${it.label.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}
            >
              <it.icon className="w-5 h-5" />
              <span className="text-[14px] font-medium whitespace-nowrap">
                {it.label}
              </span>
            </div>
          ))}
        </div>
        {/* gradient fades */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0b0b12] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0b0b12] to-transparent" />
      </div>
    </section>
  );
}
